import { render, staticRenderFns } from "./CiButton.vue?vue&type=template&id=25f62910&scoped=true"
import script from "./CiButton.vue?vue&type=script&lang=js"
export * from "./CiButton.vue?vue&type=script&lang=js"
import style0 from "./CiButton.vue?vue&type=style&index=0&id=25f62910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f62910",
  null
  
)

export default component.exports